import AuthProfilesScreen from '@/components/Auth/Profiles/AuthProfilesScreen'
import { useAppSelector } from '@/hooks/redux'
import { authSelectors } from '@/redux/reducers/auth/selectors'
import { Redirect } from 'expo-router'
import { FC } from 'react'

const Page: FC = () => {
    const currentProfile = useAppSelector(authSelectors.currentProfile)

    if (currentProfile) {
        return <Redirect href="/auth/profile-pin" />
    }

    return <AuthProfilesScreen />
}

export default Page
